import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';
import type { FC } from 'react';
import React, { useContext } from 'react';

import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';
import { LoadableLazy } from '@confluence/loadable';
import { expValEquals } from '@confluence/feature-experiments';
import { useNetworkStatusListenerCache } from '@confluence/legacy-schema-bridge/entry-points/useNetworkStatusListenerCache.ts';

import type { NetworkStatusListenerQuery as TData } from './__types__/NetworkStatusListenerQuery.ts';
import { ClientNetworkStatus } from './__types__/NetworkStatusListenerQuery.ts';
import { NetworkStatusListenerQuery } from './NetworkStatusListenerQuery.graphql.ts';

const NetworkStatusFlagLoader = LoadableLazy({
	loader: () => import(/* webpackChunkName: "loadable-NetworkStatusFlag" */ './NetworkStatusFlag.tsx'),
});

export const NetworkStatusListener: FC = () => {
	const { data } = useQuery<TData>(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		NetworkStatusListenerQuery,
		{
			fetchPolicy: 'cache-only',
			skip: expValEquals('confluence_replace_apollo_client_schema', 'isEnabled', true),
		},
	);
	const networkStatus = useNetworkStatusListenerCache();
	const status = expValEquals('confluence_replace_apollo_client_schema', 'isEnabled', true)
		? networkStatus
		: data?.network?.status;
	// 1. experience-tracker
	const experienceTracker = useContext(ExperienceTrackerContext);
	let reason: string | undefined;

	switch (status) {
		case ClientNetworkStatus.IP_BLOCKED:
			reason = 'IP blocked';
			break;
		case ClientNetworkStatus.OFFLINE:
			reason = 'Network unavailable';
			break;
	}
	if (reason) {
		experienceTracker.abort({
			reason,
			checkForTimeout: false,
		});
	}

	// 2. flags
	return <NetworkStatusFlagLoader status={status} />;
};
